import { RESET_DENOMINATIONS, UPDATE_DENOMINATION_COUNT } from "../Actions/denominationActions";

const defaultDenominations = [
  { value: 500, count: 0, name: "500" },
  { value: 200, count: 0, name: "200" },
  { value: 100, count: 0, name: "100" },
  { value: 50, count: 0, name: "50" },
  { value: 20, count: 0, name: "20" },
  { value: 10, count: 0, name: "10" },
  { value: 5, count: 0, name: "5" },
  { value: 2, count: 0, name: "2" },
  { value: 1, count: 0, name: "1" },
];

export const denominationReducer = (state = defaultDenominations, action) => {
  switch (action?.type) {
    case UPDATE_DENOMINATION_COUNT: {
      const { index, count } = action?.payload;
      const updated = [...state];
      updated[index] = { ...updated[index], count };
      return updated;
    }
    case RESET_DENOMINATIONS:
      return defaultDenominations?.map((d) => ({ ...d, count: 0 }));
    default:
      return state;
  }
};

export const getDenominations = (state) => state?.denominations;
